import Http from "../Http";
import { LARAVEL_BACKEND_API_URL, API_BASE_URL } from "../Helper";

// Project Services
export function getProjects(params = {}) {
  const queryParams = new URLSearchParams(params).toString();
  return (dispatch) =>
    new Promise((resolve, reject) => {
      Http.get(`${LARAVEL_BACKEND_API_URL}projects?${queryParams}`)
        .then((res) => {
          return resolve(res.data);
        })
        .catch((err) => {
          return reject(err);
        });
    });
}

export function createProject(data) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      Http.post(`${LARAVEL_BACKEND_API_URL}projects`, data)
        .then((res) => {
          return resolve(res.data);
        })
        .catch((err) => {
          return reject(err);
        });
    });
}

export function triggerInstallerProjectNotification(projectName, projectId) {
  return () =>
    new Promise((resolve) => {
      Http.post(`${API_BASE_URL}notifications/v1/trigger-installer-project`, {
        project_name: projectName,
        project_id: projectId,
      })
        .then((res) => resolve(res.data))
        .catch((err) => {
          console.error("Error triggering installer project notification:", err);
          resolve(null);
        });
    });
}

export function getProject(projectId) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      Http.get(`${LARAVEL_BACKEND_API_URL}projects/${projectId}`)
        .then((res) => {
          return resolve(res.data);
        })
        .catch((err) => {
          return reject(err);
        });
    });
}

export function updateProject(projectId, data) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      Http.patch(`${LARAVEL_BACKEND_API_URL}projects/${projectId}`, data)
        .then((res) => {
          return resolve(res.data);
        })
        .catch((err) => {
          return reject(err);
        });
    });
}

export function deleteProject(projectId) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      Http.delete(`${LARAVEL_BACKEND_API_URL}projects/${projectId}`)
        .then((res) => {
          return resolve(res.data);
        })
        .catch((err) => {
          return reject(err);
        });
    });
}

// Project Images Services
export function getProjectImages(projectId) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      Http.get(`${LARAVEL_BACKEND_API_URL}projects/${projectId}/images`)
        .then((res) => {
          return resolve(res.data);
        })
        .catch((err) => {
          return reject(err);
        });
    });
}

export function uploadProjectImage(projectId, data) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      Http.post(`${LARAVEL_BACKEND_API_URL}projects/${projectId}/images`, data)
        .then((res) => {
          return resolve(res.data);
        })
        .catch((err) => {
          return reject(err);
        });
    });
}

export function getProjectImage(projectId, imageId) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      Http.get(`${LARAVEL_BACKEND_API_URL}projects/${projectId}/images/${imageId}`)
        .then((res) => {
          return resolve(res.data);
        })
        .catch((err) => {
          return reject(err);
        });
    });
}

export function updateProjectImage(projectId, imageId, data) {
  console.info({ projectId, imageId, data })
  return (dispatch) =>
    new Promise((resolve, reject) => {
      Http.post(`${LARAVEL_BACKEND_API_URL}projects/${projectId}/images/${imageId}?_method=PATCH`, data, {
      })
        .then((res) => {
          return resolve(res.data);
        })
        .catch((err) => {
          return reject(err);
        });
    });
}

export function deleteProjectImage(projectId, imageId) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      Http.delete(`${LARAVEL_BACKEND_API_URL}projects/${projectId}/images/${imageId}`)
        .then((res) => {
          return resolve(res.data);
        })
        .catch((err) => {
          return reject(err);
        });
    });
}

export function getProjectTrashImages(projectId) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      Http.get(`${LARAVEL_BACKEND_API_URL}projects/${projectId}/images/trash`)
        .then((res) => {
          return resolve(res.data);
        })
        .catch((err) => {
          return reject(err);
        });
    });
}

export function restoreProjectImage(projectId, imageId) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      Http.post(`${LARAVEL_BACKEND_API_URL}projects/${projectId}/images/${imageId}/restore`)
        .then((res) => {
          return resolve(res.data);
        })
        .catch((err) => {
          return reject(err);
        });
    });
}

export function restoreProjectImagesBatch(projectId, imageIds) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      Http.post(`${LARAVEL_BACKEND_API_URL}projects/${projectId}/images/restore-batch`, { image_ids: imageIds })
        .then((res) => {
          return resolve(res.data);
        })
        .catch((err) => {
          return reject(err);
        });
    });
}

export function restoreProjectVideo(videoId) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      Http.post(`${LARAVEL_BACKEND_API_URL}media/${videoId}/restore`)
        .then((res) => {
          return resolve(res.data);
        })
        .catch((err) => {
          return reject(err);
        });
    });
}

export function restoreProjectVideosBatch(videoIds) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      Http.post(`${LARAVEL_BACKEND_API_URL}media/restore-batch`, { media_ids: videoIds })
        .then((res) => {
          return resolve(res.data);
        })
        .catch((err) => {
          return reject(err);
        });
    });
}

export function downloadOriginalImage(projectId, imageId) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      Http.get(`${LARAVEL_BACKEND_API_URL}projects/${projectId}/images/${imageId}/original`)
        .then((res) => {
          return resolve(res.data);
        })
        .catch((err) => {
          return reject(err);
        });
    });
}

export function duplicateProjectImage(projectId, imageId) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      Http.post(`${LARAVEL_BACKEND_API_URL}projects/${projectId}/images/${imageId}/duplicate`)
        .then((res) => {
          return resolve(res.data);
        })
        .catch((err) => {
          return reject(err);
        });
    });
}

export function updateProjectImageWithoutProjectId(imageId, data) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      Http.post(`${LARAVEL_BACKEND_API_URL}inspection-images/${imageId}?_method=PATCH`, data, {
      })
        .then((res) => {
          return resolve(res.data);
        })
        .catch((err) => {
          return reject(err);
        });
    });
}

export function assignProjectInstallers(projectId, installerIds) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      Http.post(`${LARAVEL_BACKEND_API_URL}projects/${projectId}/assign-installers`, {
        installer_ids: installerIds,
      })
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    });
}

export function getAssignedProjectInstallers(projectId) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      Http.get(`${LARAVEL_BACKEND_API_URL}projects/${projectId}/assigned-installers`)
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    });
}

export function batchReorderImages(projectId, orders) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      Http.post(`${LARAVEL_BACKEND_API_URL}projects/${projectId}/images/reorder`, {
        orders: orders,
      })
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    });
}

export function archiveProject(projectId) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      Http.patch(`${LARAVEL_BACKEND_API_URL}projects/${projectId}/archive`)
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    });
}

export function unarchiveProject(projectId) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      Http.patch(`${LARAVEL_BACKEND_API_URL}projects/${projectId}/unarchive`)
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    });
}

export function getProjectHistory(projectId) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      Http.get(`${LARAVEL_BACKEND_API_URL}projects/${projectId}/history`)
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    });
}